import { Component } from "@angular/core";

@Component({
  selector: "facebook-platform",
  templateUrl: "./facebook-platform.component.html",
  styleUrls: ["./facebook-platform.component.scss"],
})
export class FacebookPlatformComponent {
  ratioOptions = [{ ratio: "16:9" }, { ratio: "1:1" }];
}
